import { Attachment, Translations, UUID } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { Asset } from './AssetApi';
import { ProductModuleCollection } from './ProductModuleCollectionApi';
import { PriceGroup } from './PriceGroupApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum ProductModuleType {
	LINE = 'LINE',
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
	T = 'T',
}

export interface ProductModulePriceGroup extends BaseEntity {
	priceGroup: PriceGroup;
	price: number;
}

export interface ProductModule extends BaseEntity {
	name: string;
	code: string;
	description: string;
	image?: Attachment;
	productModuleCollection: ProductModuleCollection;
	price: number;
	asset: Asset;
	listOrder: number;
	moduleType: ProductModuleType;
	isActive: boolean;
	productModulePriceGroups: ProductModulePriceGroup[];
	modulesBlacklist?: ProductModule[];
	modulesBlacklistIds: UUID[];
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class ProductModuleApi extends EntityApi<ProductModule> {
	constructor() {
		super(ApiQueryKey.productModules);
		this.updatePriceGroups = this.updatePriceGroups.bind(this);
	}

	async updatePriceGroups(data: [ProductModule, ProductModulePriceGroup[]][]) {
		const requests: Promise<ProductModule>[] = [];

		for (const [productModule, productModulePriceGroups] of data) {
			requests.push(
				super.update({
					id: productModule.id,
					productModulePriceGroups,
				})
			);
		}

		await Promise.all(requests);
	}
}

export default new ProductModuleApi();
